import React from "react";

interface FilterButtonProps {
  onClick: () => void;
  style?: React.CSSProperties;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  style,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 12px",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        backgroundColor: "white",
        color: "#212121",
        fontSize: "14px",
        cursor: "pointer",
        outline: "none",
        ...style,
      }}
    >
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.728556 0.719426C0.837795 0.483983 1.07375 0.333344 1.3333 0.333344H14.6666C14.9262 0.333344 15.1621 0.483983 15.2714 0.719426C15.3806 0.954868 15.3433 1.23231 15.1757 1.43049L9.99997 7.55078V13C9.99997 13.2311 9.88033 13.4456 9.68379 13.5671C9.48724 13.6886 9.24182 13.6996 9.03516 13.5963L6.36849 12.263C6.14264 12.15 5.99997 11.9192 5.99997 11.6667V7.55078L0.824255 1.43049C0.656657 1.23231 0.619318 0.954868 0.728556 0.719426ZM2.77017 1.66668L7.17568 6.87619C7.27746 6.99654 7.3333 7.14906 7.3333 7.30668V11.2547L8.66664 11.9213V7.30668C8.66664 7.14906 8.72248 6.99654 8.82425 6.87619L13.2298 1.66668H2.77017Z"
          fill="#212121"
        />
      </svg>
      Filters
    </button>
  );
};
